import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Quotations from './pages/Quotations';
import QuotationForm from './pages/QuotationForm';
import Invoices from './pages/Invoices';
import InvoiceForm from './pages/InvoiceForm';
import Renewals from './pages/Renewals';
import Settings from './pages/Settings';
import Users from './pages/Users';
import './App.css';

function Loader() {
  return (
    <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'var(--bg)' }}>
      <div style={{ textAlign:'center' }}>
        <div className="spinner spinner-dark" style={{ width:36,height:36,margin:'0 auto 12px' }}/>
        <div style={{ color:'var(--text3)',fontSize:13 }}>Loading…</div>
      </div>
    </div>
  );
}

function ProtectedRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="quotations" element={<Quotations />} />
        <Route path="quotations/new" element={<QuotationForm />} />
        <Route path="quotations/:id/edit" element={<QuotationForm />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="invoices/new" element={<InvoiceForm />} />
        <Route path="invoices/:id/edit" element={<ProtectedRoute adminOnly><InvoiceForm /></ProtectedRoute>} />
        <Route path="renewals" element={<Renewals />} />
        <Route path="settings" element={<Settings />} />
        <Route path="users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AppRoutes />
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background:'var(--bg3)', color:'var(--text)', border:'1px solid var(--border)', fontFamily:'DM Sans,sans-serif', fontSize:'13.5px', borderRadius:'10px' },
              success: { iconTheme: { primary:'var(--ok)', secondary:'white' } },
              error:   { iconTheme: { primary:'var(--err)', secondary:'white' } }
            }}
          />
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
